/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

type LinkedSpace = {
	linkedSpaceId: number;
	spaceKey: string;
	spaceName: string;
	spaceUrl?: string;
	spaceSettingsUrl?: string;
};

export const servicedeskVirtualAgentAiAnswersKbResource: RouteResource<LinkedSpace[]> =
	createResource<LinkedSpace[]>({
		type: 'SERVICEDESK_VIRTUAL_AGENT_AI_ANSWERS_KB_RESOURCE',
		getKey: ({ match: { params } }) => params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-virtual-agent-ai-answers", jiraSpaEntry: "async-resource-servicedesk-virtual-agent-ai-answers" */ './fetchKnoledgebases.tsx'
			),
		isBrowserOnly: true, // remove when apollo sorts our permissions to linked-spaces API
	});
